module.exports = __webpack_public_path__ + "staticcomp/img/content_2.e3b3be7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/10/content_2.jpg
// module id = 6RX2
// module chunks = 39